<template>
  <div class="donator_step1">
   <div class="container">
   	<div class="row">
   		<div class="col-md-12">
        <h3>Stap 2</h3>
   			<h1>Mogelijkheden</h1>
        <p>Bedankt dat u &euro;{{ amount }} wilt doneren! <br> Op welke manieren wilt u dit doen?</p>
   		</div>
   	</div>
    <div class="row">
      <div class="col-md-4">
        <h3>QR-code</h3>
        <p>Kies uw bank en scan daarna de onderstaande code met de app van de geselecteerde bank</p>
        <select name="bank" id="bank">
          <option value="ING">ING</option>
        </select>
        <img src="http://schisisonderzoek.loc/wp-content/plugins/qr-code-bank/index.php?name_receiver=Steunstichting%20UMC%20St%20Radboud%20onder%20vermelding%20van%20Schisis%20305210&iban_receiver=NL05ABNA0417597207&amount=5&message=Donatie%20aan%20Vrienden%20van%20schisisonderzoek&bank_bic=INGBNL2B" style="width:100%;">
      </div>  
      <div class="col-md-4">
        <h3>iDeal of PayPal</h3>
        <p>Maak gebruik van iDeal of PayPal. LET OP! Deze transactie kost geld, wanneer u deze optie kiest gaat niet het volledige bedrag naar de stichting.</p>
        <p><a href="http://paypal.com"><button>PayPal</button></a><a href="http://ideal.nl"><button>iDeal</button></a></p>
      </div>
      <div class="col-md-4">
        <h3>Zelfstandig</h3>
        <p>Liever zelf de controle over de transactie? Gebruik dan de onderstaande gegevens:</p>
        <p><strong>Rekeningnummer:</strong> <br> NL05ABNA0417597207</p>
        <p><strong>T.N.V.:</strong> <br> Steunstichting UMC St Radboud onder vermelding van Schisis 305210</p>
        <router-link :to="{ name: 'Donate_thankyou' }"><button>Gedoneerd?</button></router-link>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'Donate_step2',
  data(){
    return {
      amount: this.$route.params.amount
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/donate/Step2.vue